function novaBannerGridInit() {
  const allBlocks = document.querySelectorAll(".nova-video-loop");
  const isDesktop = window.innerWidth > 1024;
  allBlocks.forEach(block => {
    if (isDesktop) {
      if (block.classList.contains("play-on-hover")) {
        const blockCard = block.closest(".banner-grid__card");
        blockCard.addEventListener("mouseover", () => {
          block.play();
        });
        blockCard.addEventListener("mouseout", () => {
          block.pause();
        });
      } else {
        block.play();
      }
    } else {
      setTimeout(() => {
        const isPlaying =
          block.currentTime > 0 && !block.paused && !block.ended && block.readyState > block.HAVE_CURRENT_DATA;
        if (!isPlaying) {
          block.play();
        }
      }, 10);
    }
  });
}
novaBannerGridInit();
